export const ACCESSORIES_PIDS = [
  106, 114, 116, 117, 132, 136, 161, 169, 179, 196, 216, 219, 233, 234, 235, 238, 241, 274, 277, 281, 283, 284, 285,
  288, 292, 293, 299, 307, 313, 330, 335, 337, 338, 341, 342, 343, 349, 351, 352, 355, 358, 361, 366, 367, 368, 369,
  370, 373, 374, 376, 377, 383, 393, 394, 395, 401, 405, 406, 407, 411, 412, 415, 416, 417, 418, 419, 420, 421, 422,
  425, 426, 427, 429, 430, 434, 435, 436, 440, 444, 446, 447, 448, 453, 454, 455, 456, 457, 458, 459, 460, 461, 463,
  464, 467, 468, 469, 472, 475, 476, 477, 478, 479, 480, 482, 486, 487, 488, 489, 490, 491, 492, 494, 495, 496, 497,
  498, 499, 500, 501, 502, 503, 507, 512, 513, 514, 515, 517, 519, 525, 526, 527, 528, 529, 530, 531, 532, 533, 534,
  535, 536, 537, 538, 539, 540, 541, 542, 544, 545, 546, 550, 551, 552, 553, 554, 555, 556, 557, 558, 559, 560, 561,
  562, 563, 564, 565, 566, 567, 568, 573, 575, 576, 587, 588, 589, 592, 593, 594, 598, 599, 600, 601, 602, 603, 604,
  605, 606, 607, 608, 609, 610, 612, 614, 618, 619, 620, 621, 622, 623, 624, 625, 626, 630, 631, 632, 633, 634, 635,
  637, 638, 639, 640, 642, 644,
];

export const ACCESSORIES_PIDS_SET = new Set(ACCESSORIES_PIDS);
